import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material'
import { ReactNode } from 'react'

export interface LabeledCheckboxProps extends Omit<CheckboxProps, 'onChange'> {
  label: string | ReactNode
  checked: boolean
  onChange: (checked: boolean) => void
}

export const LabeledCheckbox = ({ label, checked, onChange, ...otherProps }: LabeledCheckboxProps) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...otherProps}
          checked={checked}
          onChange={(e) => {
            onChange(e.currentTarget.checked)
          }}
        />
      }
      label={label}
    />
  )
}
